import { motion } from "framer-motion";
import React from "react";
import TopImage from "../../components/TopImage";
import imgce9f86d084ddc1e80da3b2479c9625a2 from "../../img/ce9f86d084ddc1e80da3b2479c9625a2.jpg";
import woman from "../../img/woman.svg";

export default function ConsolidationOfElectric() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <TopImage
        image={imgce9f86d084ddc1e80da3b2479c9625a2}
        title={"Консолидация электросетевого имущества"}
      />
      <div className="page-grid__content" id="content">
        {/* 2 абзаца текста вверху страницы */}
        <div className="text-area">
          <p>
            Уважаемые Заявители, АО «Мособлэнерго» проводит работу по
            консолидации объектов электросетевого хозяйства физических лиц (или
            группы лиц), юридических лиц и некоммерческих организаций на
            территории Московской области.
          </p>
          <p>
            Целью консолидации является повышение эффективности эксплуатации
            объектов и качества потребляемой электроэнергии, а также создание
            единых условий по технологическому присоединению потребителей.
          </p>
        </div>
        {/* Документы, предоставляемые физическими лицами */}
        <div
          className="accordion-row"
          onClick={(event) => {
            event.currentTarget.classList.toggle("open-accordion");
            event.currentTarget
              .querySelector(".accordion-row__up")
              .classList.toggle("active");
            const drop = event.currentTarget.querySelector(
              ".accordion-row__drop-down"
            );
            if (drop.style.maxHeight == "") {
              drop.style.maxHeight = `${drop.scrollHeight}px`;
            } else {
              drop.style.maxHeight = "";
            }
          }}
        >
          <div className="accordion-row__up">
            <span className="accordion-row__text">
              Документы, предоставляемые физическими лицами
            </span>
            <div className="accordion-row__wrap-arrow">
              <svg className="accordion-row__arrow">
                <use href="img/arrow-nav.svg#arrow-nav"></use>
              </svg>
            </div>
          </div>
          <div className="accordion-row__drop-down">
            <div className="accordion-row__wrapper">
              <div className="text-area">
                <div
                  className="text-area"
                  id="i-13-i-12-bitrix-news-detail-default-IjWcdmnFDmaA"
                >
                  {/* <ul className="grid-list">
                    <li>
                      Официальное письмо от собственника имущества на имя
                      генерального директора АО «Мособлэнерго» с предложением
                      передачи имущества и указанием контактного лица,
                      ответственного за проведение предварительных переговоров;
                    </li>
                    <li>Копия гражданского паспорта;</li>
                    <li>
                      От каждого участника/собственника согласие на обработку
                      персональных данных (в соответствии с требованиями
                      Федерального закона от 27.07.2006 N 152-ФЗ "О персональных
                      данных»);
                    </li>
                    <li>
                      Протокол общего собрания индивидуальных собственников;
                    </li>
                    <li>
                      Документы, подтверждающие полномочия лица подписывать
                      договор от имени контрагента;
                    </li>
                    <li>
                      Карточка контрагента, содержащая все реквизиты,
                      необходимые для заключения сделки;
                    </li>
                    <li>
                      Выписка из ЕГРП об отсутствии обременений - для
                      недвижимого имущества;
                    </li>
                    <li>
                      Копия договора энергоснабжения с владельцем
                      электросетевого имущества с приложениями (Приложение 1, 2
                      к договору);
                    </li>
                    <li>
                      Акт разграничения балансовой принадлежности электросетей и
                      эксплуатационной ответственности сторон;
                    </li>
                    <li>
                      Перечень присоединенных (в том числе опосредованно)
                      потребителей с указанием имеющихся приборов учета
                      электроэнергии;
                    </li>
                    <li>
                      Реестр договоров энергоснабжения потребителей,
                      технологически присоединенных к электросетевым объектам;
                    </li>
                    <li>
                      Копии имеющихся актов разграничения балансовой
                      принадлежности электросетей и эксплуатационной
                      ответственности сторон с потребителями;
                    </li>
                    <li>
                      Копии технических условий на присоединение (разрешений на
                      мощность);
                    </li>
                    <li>
                      Плановые объемы электропотребления потребителей,
                      присоединенных к электросети владельца (в том числе
                      опосредованно);
                    </li>
                    <li>
                      Прогнозные годовые объемы потерь электрической энергии;
                    </li>
                    <li>
                      Соглашение потребителей к подписанию актов разграничения
                      балансовой принадлежности электросетей и переоформлению
                      договоров энергоснабжения (в том числе в случае изменения
                      уровня напряжения, применяемого при расчетах за
                      потребленную электроэнергию) с получением соответствующего
                      подтверждения (гарантийное письмо);
                    </li>
                    <li>
                      Акт ввода объекта в эксплуатацию, договор купли-продажи,
                      договор подряда с актом приёма передачи (если
                      инвестиционный контракт, то акты реализации
                      инвестиционного контракта) решение суда и т.д. на
                      электросетевое имущество;
                    </li>
                    <li>
                      Документы, подтверждающие права на земельный участок, на
                      котором расположено электросетевое имущество (право
                      собственности, право аренды и т.д., подтвержденное
                      соответствующими правоустанавливающими и
                      правоудостоверяющими документами, выписка из кадастрового
                      плана или кадастровый паспорт земельного участка);
                    </li>
                    <li>
                      Техническая документация (акт допуска в эксплуатацию,
                      технические или кадастровые паспорта недвижимых объектов);
                    </li>
                    <li>
                      План расположения энергопринимающих устройств заявителя.
                    </li>
                    <li>
                      В особых случаях возможен запрос иных документов, которые
                      в установленных законодательством случаях необходимы для
                      проверки законности сделки.
                    </li>
                  </ul> */}
                  <ul className="grid-list">
                    <li>
                      Заявление от собственника(-ов) объекта(-ов) (доверенного
                      лица) электросетевого имущества (далее – Объект(-ы)) на
                      имя генерального директора АО «Мособлэнерго» (Бойко
                      Владимир Александрович) о передаче Объекта(-ов) в
                      собственность АО «Мособлэнерго» с указанием состава
                      имущества, его местонахождения, существенных условий
                      сделки, контактных данных (ФИО ответственного лица, номер
                      телефона, электронный адрес).
                    </li>
                    <li>
                      Доверенность на представителя собственника Объекта(-ов).
                    </li>
                    <li>
                      Протокол общего собрания собственников (при общей
                      собственности) с решением о передаче сетевой организации
                      Объекта(-ов) с указанием существенных условий сделки.
                    </li>
                    <li>
                      Документы, подтверждающие право собственности на
                      предлагаемые к передаче объекты (акт ввода Объекта(-ов) в
                      эксплуатацию, разрешение на допуск электроустановки в
                      эксплуатацию, договор купли-продажи, договор подряда с
                      актом приёма передачи, решение суда и т.д.).
                    </li>
                    <li>
                      Документы, подтверждающие право собственности/пользования
                      на земельный участок, на котором расположены Объект(-ы),
                      либо документ, подтверждающий согласование размещения
                      Объекта(-ов) на земельном участке.
                    </li>
                    <li>
                      Актуальная выписка из ЕГРН на объекты недвижимого
                      имущества.
                    </li>
                    <li>
                      Документы о технологическом присоединении:{" "}
                      <ul className="grid-list"></ul> - технические условия;{" "}
                      <ul className="grid-list"></ul> - акт об осуществлении
                      технологического присоединения;{" "}
                      <ul className="grid-list"></ul> - акт разграничения
                      балансовой принадлежности электросетей;{" "}
                      <ul className="grid-list"></ul> - акт разграничения
                      эксплуатационной ответственности сторон.{" "}
                      <ul className="grid-list"></ul>
                    </li>
                    <li>
                      Перечень присоединенных (в том числе опосредованно)
                      потребителей с указанием имеющихся приборов учета
                      электроэнергии.
                    </li>
                    <li>
                      Реестр договоров энергоснабжения потребителей,
                      технологически присоединенных к Объекту(-ам).
                    </li>
                    {/* Примечание */}
                    <div className="text-area">
                      <p>
                        <b>Примечание:</b> При принятии решения о приобретении
                        Объектов АО «Мособлэнерго» будут запрошены
                        дополнительные документы (при общей собственности – от
                        каждого участника):
                      </p>
                    </div>
                    <li>Копия гражданского паспорта.</li>
                    <li>Идентификационный номер налогоплательщика (ИНН).</li>
                    <li>
                      Согласие на обработку персональных данных в соответствии с
                      требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О
                      персональных данных».
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Документы, предоставляемые юридическими лицами */}
        <div
          className="accordion-row"
          onClick={(event) => {
            event.currentTarget.classList.toggle("open-accordion");
            event.currentTarget
              .querySelector(".accordion-row__up")
              .classList.toggle("active");
            const drop = event.currentTarget.querySelector(
              ".accordion-row__drop-down"
            );
            if (drop.style.maxHeight == "") {
              drop.style.maxHeight = `${drop.scrollHeight}px`;
            } else {
              drop.style.maxHeight = "";
            }
          }}
        >
          <div className="accordion-row__up">
            <span className="accordion-row__text">
              Документы, предоставляемые юридическими лицами
            </span>
            <div className="accordion-row__wrap-arrow">
              <svg className="accordion-row__arrow">
                <use href="img/arrow-nav.svg#arrow-nav"></use>
              </svg>
            </div>
          </div>

          <div className="accordion-row__drop-down">
            <div className="accordion-row__wrapper">
              <div className="text-area">
                <div
                  className="text-area"
                  id="i-13-i-12-bitrix-news-detail-default-IjWcdmnFDmaA"
                >
                  <ul className="grid-list">
                    <li>
                      Заявление от собственника(-ов) объекта(-ов) (доверенного
                      лица) электросетевого имущества (далее – Объект(-ы) на имя
                      генерального директора АО «Мособлэнерго» (Бойко Владимир
                      Александрович) о передаче Объекта(-ов) в собственность АО
                      «Мособлэнерго» с указанием состава имущества, его
                      местонахождения, существенных условий сделки, контактных
                      данных (ФИО ответственного лица, номер телефона,
                      электронный адрес).
                    </li>

                    <li>
                      Доверенность на представителя собственника Объекта(-ов).
                    </li>

                    <li>
                      Копия устава с зарегистрированными изменениями и
                      дополнениями к нему.
                    </li>

                    <li>
                      Копия свидетельства о государственной регистрации
                      юридического лица (ОГРН).
                    </li>

                    <li>
                      Копия свидетельства о постановке юридического лица на
                      налоговый учет (ИНН).
                    </li>

                    <li>
                      Документ, подтверждающий применение упрощённой системы
                      налогообложения (при наличии).
                    </li>

                    <li>
                      Карточка контрагента, содержащая все реквизиты,
                      необходимые для заключения сделки.
                    </li>

                    <li>
                      Решение уполномоченного органа юридического лица о продаже
                      Объекта(-ов) сетевой организации с указанием цены сделки
                      (пообъектно).
                    </li>

                    <li>
                      Документы, подтверждающие право собственности на
                      предлагаемые к передаче объекты (акт ввода Объекта(-ов) в
                      эксплуатацию, разрешение на допуск электроустановки в
                      эксплуатацию, договор купли-продажи, договор подряда с
                      актом приёма передачи, инвестиционный контракт с актом
                      реализации инвестиционного контракта, решение суда и
                      т.д.).
                    </li>

                    <li>
                      Документы, подтверждающие право собственности/пользования
                      на земельныйучасток, на котором расположены Объект(-ы),
                      либо документ, подтверждающий согласование размещения
                      Объекта(-ов) на земельном участке.
                    </li>

                    <li>
                      Актуальная выписка из ЕГРН на объекты недвижимого
                      имущества.
                    </li>

                    <li>
                      Кадастровый паспорт на объекты недвижимого имущества.
                    </li>

                    <li>Справка о балансовой стоимости Объекта(-ов).</li>

                    <li>
                      Копия договора энергоснабжения с гарантирующим поставщиком
                      электроэнергии и владельцем Объекта(-ов) с приложениями
                      (Приложение 1, 2 к договору энергоснабжения).
                    </li>

                    <li>
                      Документы о технологическом присоединении:
                      <ul className="grid-list"></ul> - технические условия;
                      <ul className="grid-list"></ul> - акт об осуществлении
                      технологического присоединения;
                      <ul className="grid-list"></ul> - акт разграничения
                      балансовой принадлежности электросетей;
                      <ul className="grid-list"></ul> - акт разграничения
                      эксплуатационной ответственности сторон.
                      <ul className="grid-list"></ul>
                    </li>

                    <li>
                      Перечень присоединенных (в том числе опосредованно)
                      потребителей с указанием имеющихся приборов учета
                      электроэнергии.
                    </li>

                    <li>
                      Реестр договоров энергоснабжения потребителей,
                      технологически присоединенных к Объекту(-ам).
                    </li>

                    <li>
                      Плановые объемы электропотребления потребителей,
                      присоединенных к электросети владельца (в том числе
                      опосредованно).
                    </li>

                    <li>
                      Прогнозные годовые объемы потерь электрической энергии.
                    </li>

                    <li>
                      Техническая, проектная и исполнительная документация.
                    </li>

                    {/* Примечание */}
                    <div className="text-area">
                      <p>
                        <b>Примечание:</b> Возможен запрос дополнительных
                        документов, которые в установленном законодательством
                        порядке необходимы для совершения сделки.
                      </p>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Контактная информация */}
        <div
          className="accordion-row"
          onClick={(event) => {
            event.currentTarget.classList.toggle("open-accordion");
            event.currentTarget
              .querySelector(".accordion-row__up")
              .classList.toggle("active");
            const drop = event.currentTarget.querySelector(
              ".accordion-row__drop-down"
            );
            if (drop.style.maxHeight == "") {
              drop.style.maxHeight = `${drop.scrollHeight}px`;
            } else {
              drop.style.maxHeight = "";
            }
          }}
        >
          <div className="accordion-row__up">
            <span className="accordion-row__text">Контактная информация</span>
            <div className="accordion-row__wrap-arrow">
              <svg className="accordion-row__arrow">
                <use href="img/arrow-nav.svg#arrow-nav"></use>
              </svg>
            </div>
          </div>
          <div className="accordion-row__drop-down">
            <div className="accordion-row__wrapper">
              <div className="text-area">
                <div className="leadership">
                  <div className="positions-grid">
                    <div className="positions-post">
                      <div className="positions-post__up">
                        <div className="positions-post__wrap-image">
                          <img src={woman} alt="Woman" title="" />
                        </div>
                      </div>
                      <div className="positions-post__down">
                        <div className="positions-post__row-name">
                          {" "}
                          <h4 className="positions-post__name">Специалист</h4>
                          <h4 className="positions-post__name-two">
                            {/* департамента корпоративного управления имуществом */}
                            Департамента по корпоративному управлению и
                            собственности
                          </h4>
                        </div>{" "}
                        <div className="positions-post__wrap-text">
                          <span></span>
                        </div>
                        <span className="positions-post__tel">
                          8 (495) 780-39-62 доб. 11-58{" "}
                        </span>
                      </div>
                    </div>
                    <div className="positions-post">
                      <div className="positions-post__up">
                        <div className="positions-post__wrap-image">
                          <img src={woman} alt="Woman" title="" />
                        </div>
                      </div>
                      <div className="positions-post__down">
                        <div className="positions-post__row-name">
                          {" "}
                          <h4 className="positions-post__name">Специалист</h4>
                          <h4 className="positions-post__name-two">
                            {/* департамента корпоративного управления имуществом */}
                            Департамента по корпоративному управлению и
                            собственности
                          </h4>
                        </div>{" "}
                        <div className="positions-post__wrap-text">
                          <span></span>
                        </div>
                        <span className="positions-post__tel">
                          8 (495) 780-39-62 доб. 10-95{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
